var formatNumbersOnly = function formatNumbersOnly(value) {
  return (value.match(/[0-9]/g) || []).join('');
};

export default formatNumbersOnly;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@allpro/form-manager/es/formatters/formatNumbersOnly.js
// module id = 534
// module chunks = 0